import { create } from 'zustand';

interface LoaderStore {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const useGlobalLoaderStore = create<LoaderStore>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set(() => ({ isLoading })),
}));
